// extracted by mini-css-extract-plugin
export var accordion = "_az-0";
export var chevron = "_az-3";
export var closed = "_az-2";
export var content = "_az-4";
export var open = "_az-1";
export var rotate = "_az-5";